<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-btn size="small" variant="text" v-bind="props" style="text-transform: none;">
        <template #default>
          <span v-if="$user">
            <v-avatar v-if="$page.props.jetstream.managesProfilePhotos" class="border border-md">
              <v-img :src="$user.profile_photo_url" :alt="$user.name" lazy-src="/images/user.png" />
            </v-avatar>
            <span v-else>
              <p class="my-0" style="white-space: break-spaces; max-width: 77px; word-break: break-word;">{{ $user.name
                }}</p>
            </span>
          </span>
          <span v-else>
            <p class="my-0">Login &</p>
            <p class="my-0">Register</p>
          </span>
        </template>
      </v-btn>
    </template>
    <v-list v-if="!$user">
      <v-list-item :href="route('login')" @click.stop.prevent="goTo(route('login'))" title="Login"
        prepend-icon="mdi-login-variant" />
      <v-list-item :href="route('register')" @click.stop.prevent="goTo(route('register'))" title="Register"
        prepend-icon="mdi-account-plus" />
      <v-divider></v-divider>
      <v-list-item @click="toggleTheme" prepend-icon="mdi-theme-light-dark" title="Toggle Theme"
        subtitle="Choose between Light & Dark mode" />
    </v-list>
    <v-list density="comfortable" v-else>
      <v-list-item :href="route('profile.show')" @click.stop.prevent="goTo(route('profile.show'))" title="Profile"
        subtitle="Change password & more." prepend-icon="mdi-account-edit-outline" />
      <v-list-item v-if="$page.props.jetstream.hasApiFeatures" :href="route('api-tokens.index')"
        @click.stop.prevent="goTo(route('api-tokens.index'))" title="API Tokens" />
      <v-list-item :href="route('usage.index')" @click.stop.prevent="goTo(route('usage.index'))" title="API Usage" />
      <v-list-item title="System Settings" subtitle="View and change system settings" prepend-icon="mdi-cogs"
        :href="route('settings.index')" @click.stop.prevent="goTo(route('settings.index'))"></v-list-item>
      <v-list-item @click.prevent="goTo('/admin')" title="Admin" subtitle="View Admin Dashboard"
        prepend-icon="mdi-folder-lock" base-color="error" v-if="$user.is_admin"></v-list-item>
      <v-divider></v-divider>
      <v-list-item @click.stop.prevent="logout" title="Logout" subtitle="End your session" base-color="warning"
        append-icon="mdi-logout-variant" />
      <v-divider color="warning" class="border-opacity-50"></v-divider>
      <v-list-item @click="toggleTheme" prepend-icon="mdi-theme-light-dark" title="Toggle Theme"
        subtitle="Choose between Light & Dark mode" />
    </v-list>
  </v-menu>
</template>

<script setup>

import { inject, onMounted } from 'vue'
import { router } from '@inertiajs/vue3'
import { toast } from '@/Mixins/toast'
import { useVuetify } from '@/Composables/useVuetify.js'

const $cookies = inject('$cookies')
const $user = inject('$user')

const { toggleTheme } = useVuetify()

defineOptions({
  name: 'UserMenu'
})

function _checkLogin() {
  let checked = $cookies.get('auto_login')
  if (!checked) {
    $cookies.set('auto_login', 'checked', { expires: '1m' })
  }
  let loggedOutManually = $cookies.get('logged_out_manually')
  if (loggedOutManually) {
    return
  }
  if (window.PasswordCredential || window.FederatedCredential) {
    if (!$user.value) {
      navigator.credentials.get({
        password: true,
        mediation: 'optional'
      }).then(c => {
        // console.log('C ', c)
        if (c) {
          switch (c.type) {
            case 'password':
              return login(c);
              break;
            case 'federated':
              // return gSignIn(c);
              break;
          }
        } else {
          return Promise.resolve();
        }
      }).then(profile => {
        if (profile) {
          // updateUI(profile);
        }
      }).catch(error => {
        console.error(error, 'PasswordCredential Error');
      });
    }
  }
}

function login(c) {
  let data = {
    email: c.id,
    password: c.password,
    remember: true,
  }
  router.post(route('login'), data, {
    preserveState: true,
    preserveScroll: true,
    onSuccess: () => {
      toast('Logged in successfully using the saved credentials on your device.', {
        type: 'success',
      })
    }
  })
}

function logout() {
  $cookies.set('logged_out_manually', true, { expires: '1d' })
  $cookies.remove('auto_login')
  router.post(route('logout'))
}

onMounted(() => {
  _checkLogin()
})

</script>

<style>
body {
  background-image: linear-gradient(to top left, rgba(var(--v-theme-background), .85), rgba(var(--v-theme-background), .95)), url(/images/background.webp);
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
</style>
